/* VEGECORE — subtle scroll parallax
   Respects prefers-reduced-motion; desktop only (>=750px).
   Targets any [data-parallax] element; sets --vc-py used by CSS. */
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var els = [];
  function collect(){ els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]')); }
  var enabled = false, ticking = false;
  function update(){
    ticking = false;
    var mid = window.innerHeight / 2;
    for (var i=0;i<els.length;i++){
      var el = els[i];
      var r = el.getBoundingClientRect();
      var elMid = r.top + r.height/2;
      var speed = parseFloat(el.getAttribute('data-speed')) || 0.06;
      var max = parseFloat(el.getAttribute('data-max')) || 28;
      var shift = (mid - elMid) * speed;
      if (shift > max) shift = max; else if (shift < -max) shift = -max;
      el.style.setProperty('--vc-py', shift.toFixed(1) + 'px');
    }
  }
  function onScroll(){ if(!ticking){ ticking = true; requestAnimationFrame(update); } }
  function setup(){
    var desktop = window.innerWidth >= 750;
    if (desktop && !enabled){
      enabled = true;
      window.addEventListener('scroll', onScroll, {passive:true});
      update();
    } else if (!desktop && enabled){
      enabled = false;
      window.removeEventListener('scroll', onScroll);
      for (var i=0;i<els.length;i++) els[i].style.setProperty('--vc-py','0px');
    }
  }
  function init(){ collect(); setup(); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  var rt; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(function(){ collect(); setup(); if(enabled) update(); }, 150); }, {passive:true});
})();
